import { render, staticRenderFns } from "./BuyMarketHistory.vue?vue&type=template&id=61eb7f2d&scoped=true&"
import script from "./BuyMarketHistory.vue?vue&type=script&lang=js&"
export * from "./BuyMarketHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuyMarketHistory.vue?vue&type=style&index=0&id=61eb7f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb7f2d",
  null
  
)

export default component.exports